<div class="split-value-control" [class.mx-auto]="rectangleInputs" [style.max-width]="maxWidth">
  <div [formGroup]="form" class="split-value-control__row">
    <div *ngFor="let control of controls; let i = index">
      <mat-form-field [appearance]="theme" formArrayName="split">
        <input
          #fields
          matInput
          type="text"
          [formControlName]="i"
          maxlength="1"
          tabindex="0"
          (blur)="onBlur()"
          (keydown)="onKeyPress($event)"
          (paste)="onPaste($event)"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="split-value-field__error" [class.text-center]="rectangleInputs">
    <ng-content></ng-content>
  </div>
</div>
